import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DEFAULT_TITLE = 'UXOHire — The UXO Industry Job Board';

// Exact-path titles for public, indexable pages.
const TITLES = {
  '/': DEFAULT_TITLE,
  '/jobs': 'UXO Jobs | UXOHire',
  '/support': 'Support | UXOHire',
  '/terms': 'Terms of Service | UXOHire',
  '/privacy': 'Privacy Policy | UXOHire',
};

// Private route prefixes — always noindex, never appear in search results.
const NOINDEX_PREFIXES = [
  '/dashboard',
  '/employer-dashboard',
  '/employer-onboarding',
  '/admin',
  '/reset-password',
  '/create-profile',
];

const isPrivate = (path) =>
  NOINDEX_PREFIXES.some((p) => path === p || path.startsWith(p + '/'));

// Keep a single <meta name="robots"> element and toggle it per route.
function setRobots(noindex) {
  let tag = document.querySelector('meta[name="robots"]');
  if (noindex) {
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'robots');
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', 'noindex, nofollow');
  } else if (tag) {
    tag.parentNode.removeChild(tag);
  }
}

// Updates document.title and the robots meta tag whenever the route changes.
export default function RouteMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const priv = isPrivate(pathname);
    document.title = priv
      ? 'Dashboard | UXOHire'
      : TITLES[pathname] || DEFAULT_TITLE;
    setRobots(priv);
  }, [pathname]);

  return null;
}
